<template>
  <div class="planeLayout">
    <el-card>
      <el-button type="primary" slot="header" @click="addPlan()">{{$t('lang.lab_addPlan')}}</el-button>
     <el-table
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="planeLayoutscheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <!-- 平面图名称 -->
        <el-table-column prop="name" :label="$t('lang.lab_planName')"></el-table-column>
        <!-- 图片 -->
        <el-table-column prop="urls" :label="$t('lang.lab_photograph')">
          <template slot-scope="scope">
            <viewer :images="scope.row.urls">
              <img v-for="(src,index) in scope.row.urls" :src="src" :key="index" class="img" />
            </viewer>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          prop="operation"
          :label="$t('lang.lab_operation')"
          fixed="right"
          width="250px"
        >
          <template slot-scope="scope">
            <el-button @click="changeplan(scope.row.id)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="del(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
            <el-button @click="pointset(scope.row.id)">{{$t('lang.btn_pointSet')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
    <!-- 添加弹框 -->
    <el-dialog
      :visible.sync="diaIsShow"
      :close-on-click-modal="false"
      v-if="diaIsShow"
      :title="titleShow"
      center
      top="130px"
      width="600px"
      @closed="handleDialogClosed"
    >
      <!-- 表单验证 -->
      <el-form
        :rules="rules"
        ref="form"
        :model="form"
        :label-width="require('@/config/enum').c_ws5"
        :label-suffix="require('@/config/enum').c_colon"
      >
        <el-form-item :label="$t('lang.lab_planName')" prop="name">
          <el-input
            maxlength="20"
            v-model="form.name"
            :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_planName')"
          ></el-input>
        </el-form-item>
        <!-- 上传图片 -->
        <el-form-item :label="$t('lang.lab_uploadPhotograph')" prop="picture" ref="picture">
          <upload-file ref="uploading" :accept='accept'  upTypes='0' :fileList='fileList' :clears='clears' @outputFile="getFile" @removeFile='removeFile'></upload-file>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clear()">{{$t('lang.btn_rest')}}</el-button>
        <el-button
          type="primary"
          @click="save('form')"
          :disabled="isDisabled"
        >{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:planeLayouts
 *@Description:平面图设置
 *@author:李斌
 *@Copyright:格众科技
 *@date:2020-03-12
 */
import UploadFile from '../../../components/upload_file.vue'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      accept: '.jpg, .jpeg, .png',
      fileList: [], // 图片上传
      clears: false, // 清空按钮
      isDisabled: true, // 保存的可点击
      saveData: '', // 存储JSON数据
      editId: '', // 接收参数
      titleShow: '', // 弹窗标题
      diaIsShow: false, // 弹窗是否显示
      pageCount: 0, // 总页数
      pageSize: 10, // 每页显示数量
      pageNo: 1, // 多少页
      tableData: [], // 表单数据
      images: [], // 图片
      multipleSelection: [], // 多选框
      planeLayoutscheckbox: require('@/config/enum').planeLayoutscheckbox, // 是否隐藏复选框
      form: {
        name: '',
        picture: ''
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$i18n.t('lang.lab_ple_addPlanName'),
            trigger: 'blur'
          }
        ],
        picture: [
          {
            required: true,
            message: this.$i18n.t('lang.lab_ple_uploadPicture'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  components: {
		'upload-file': UploadFile
	},
  // 初始化
  created() {
    setTimeout(() => {
      window.localStorage.setItem('pointform', '')
      window.localStorage.setItem('pointradio', '')
      window.localStorage.setItem('pointsignList', '')
      window.localStorage.setItem('pointsaveDatapoint', '')
    }, 200)
    this.topics()
  },
  computed: {
      ...mapGetters(['gardenId'])
    },
  // 监听改变小区编号
  watch: {
    gardenId: function(newFlag, oldFlag) {
      this.commit()
    },
    form: {
      handler(newVal, oldVal) {
        // ruleForm数据变化时 会调用此方法
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取组件值
    getFile(e) {
      this.form.picture = e
      this.$refs.picture.clearValidate()
    },
    // 移除图片
    removeFile(e) {
      this.fileList = []
      this.form.picture = ''
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 列表斑马线
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    topics() {
      let loading = this.$loading()
      this.$get(
        `/planarGraph?pageSize=${this.pageSize}&pageNo=${this.pageNo}&GardenId=${this.gardenId}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    commit() {
      this.pageNo = 1
      this.topics()
    },
    // 添加平面图
    addPlan() {
      this.titleShow = this.$i18n.t('lang.lab_addPlan')
      this.editId = ''
      this.form.picture = ''
      this.form.name = ''
      this.fileList = []
      this.diaIsShow = true
    },
    // 修改平面图
    changeplan(id) {
      this.titleShow = this.$i18n.t('lang.lab_changePlan')
      this.editId = id
      this.fileList = []
      let loading = this.$loading()
      this.$get(`/planarGraphById/` + id).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            if (res.urls && res.urls != '') {
              this.fileList.push({
                name: '',
                url: res.urls[0]
              })
              this.form.picture = res.urls[0]
            } else {
              this.form.picture = ''
            }
            this.form.name = res.name
            this.saveData = JSON.stringify(this.form)
            this.diaIsShow = true
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 删除
    del(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          this.$delete(`planarGraph/` + id).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.commit()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    },
    // 跳转到点位设置页面
    pointset(id) {
      this.$router.push({ name: 'pointSetting', query: { id: id } })
    },
    // 保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.editId === '') {
            let params = {
              name: this.form.name,
              files: this.form.picture,
              GardenId: this.gardenId
            }
            let loading = this.$loading()
            this.$post(`/planarGraph/`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.diaIsShow = false
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            let loading = this.$loading()
            let params = {
              name: this.form.name,
              files: this.form.picture
            }
            this.$patch(`/planarGraph/${this.editId}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.diaIsShow = false
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.diaIsShow = false
                this.$message.error(error)
              }
            )
          }
        }
      })
    },
    // 清除数据
    clear() {
      this.form.name = ''
      this.fileList = []
      this.form.picture = ''
      this.clears = true
      this.$refs.form.clearValidate()
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.clear()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.topics()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.topics()
    },
  }
}
</script>

<style lang= 'scss'>
.planeLayout {
  .delete {
    color: blue;
    cursor: pointer;
  }
  .img {
    width: 80px;
    height: 50px;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
  }
}
.el-tooltip__popper.is-light {
  max-width: 300px;
}
</style>